import { DeliveryMethod, PortType } from '~/graphql/graphql';

export type Responsibility = 'seller' | 'buyer';

export const DELIVERY_METHOD_ORDER: DeliveryMethod[] = [
  DeliveryMethod.DoorToDoor,
  DeliveryMethod.PortToDoor,
  DeliveryMethod.DoorToPort,
  DeliveryMethod.PortToPort,
];

export const originIsDoor = (method: DeliveryMethod): boolean =>
  method === DeliveryMethod.DoorToDoor || method === DeliveryMethod.DoorToPort;

export const destinationIsDoor = (method: DeliveryMethod): boolean =>
  method === DeliveryMethod.DoorToDoor || method === DeliveryMethod.PortToDoor;

/**
 * Seller/buyer responsibility per journey segment [Mill→Port, Port→Port (ocean), Port→Door].
 * An explicit lookup taken from the prototype — deliberately NOT derived, so Port-to-Door and
 * Port-to-Port render identically, exactly as the prototype does.
 */
export const RESPONSIBILITY: Record<
  DeliveryMethod,
  [Responsibility, Responsibility, Responsibility]
> = {
  [DeliveryMethod.DoorToDoor]: ['seller', 'seller', 'seller'],
  [DeliveryMethod.DoorToPort]: ['seller', 'seller', 'buyer'],
  [DeliveryMethod.PortToDoor]: ['seller', 'buyer', 'buyer'],
  [DeliveryMethod.PortToPort]: ['seller', 'buyer', 'buyer'],
};

const KEBAB: Record<DeliveryMethod, string> = {
  [DeliveryMethod.DoorToDoor]: 'door-to-door',
  [DeliveryMethod.PortToDoor]: 'port-to-door',
  [DeliveryMethod.DoorToPort]: 'door-to-port',
  [DeliveryMethod.PortToPort]: 'port-to-port',
};

export const deliveryMethodLabelKey = (method: DeliveryMethod): string =>
  `cart.international.delivery_method.${method}`;

export const deliveryMethodTestId = (method: DeliveryMethod): string =>
  `international-delivery-method-${KEBAB[method]}`;

export const shouldClearLegPort = (
  portType: PortType | null | undefined,
  legIsDoor: boolean
): boolean =>
  !!portType &&
  (legIsDoor ? portType === PortType.Seaport : portType !== PortType.Seaport);
